import { getClassNames } from '../../_utils/classnames'
import React from 'react'
import { DomainDto } from '../../dtos/domain'
import { Loading3QuartersOutlined } from '@ant-design/icons'
import { Select } from '@pushly/aqe/lib/components'
import { Switch } from 'antd'
import { NamedTemplateReducerRequest } from '../app-message-builder/types'
import { AppMessageBuilderState } from '../app-message-builder/interfaces/app-message-builder-state.interface'
import './template-selector.scss'

type TemplateSelectProps = {
    config: Pick<AppMessageBuilderState, 'usingTemplate' | 'availableTemplates' | 'loading'>
    domain: DomainDto
    loading?: boolean
    value?: number
    disabled: boolean
    onChange: (data: NamedTemplateReducerRequest) => void
}

/**
 * An optional starting point for a new message: switch it on, then choose which
 * saved template to start from.
 *
 * The switch and the select sit on one line — the choice is a single decision,
 * and stacking them reads as two unrelated settings.
 */
export const TemplateSelector = (props: TemplateSelectProps) => {
    const { disabled, config, value, onChange, loading } = props

    const selectOptions = config.availableTemplates.map((t) => ({
        value: t.id,
        label: t.name,
    }))

    const toggleUsingTemplate = () => {
        if (!disabled) {
            onChange({ usingTemplate: !config.usingTemplate })
        }
    }

    return (
        <div className={getClassNames('template-selector')}>
            <span className="template-selector-label">
                <Switch
                    disabled={disabled}
                    checked={config.usingTemplate}
                    size="small"
                    onChange={toggleUsingTemplate}
                    aria-label="Use saved template"
                />
                <span role="presentation" onClick={toggleUsingTemplate}>
                    Use saved template
                </span>
            </span>

            <Select
                className="template-selector-select"
                aria-label="Select template"
                placeholder={
                    loading || !config.availableTemplates.length ? (
                        <Loading3QuartersOutlined spin={true} />
                    ) : (
                        'Select a template'
                    )
                }
                disabled={!config.usingTemplate || disabled}
                showSearch={false}
                loading={loading}
                options={selectOptions}
                onChange={(val) =>
                    onChange({
                        templateId: val as number,
                        usingTemplate: !!val,
                    })
                }
                value={value ? [value] : []}
            />
        </div>
    )
}
